module.exports = __webpack_public_path__ + "static/media/logo_encontre_seu_pai.ade8acd3.png";